import { jsx as _jsx } from "react/jsx-runtime";
import CopyField from "@iscr/xAppLib/UIelems/CopyField";
export const DocId = ({ doc_id }) => (_jsx(CopyField, { inline: true, val: doc_id, title: `Copy doctor ID ${doc_id}` }));
export const DocIdCell = ({ row }) => (_jsx("span", { className: "text-sm", children: _jsx(DocId, { doc_id: row.doc_id }) }));
